"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HexaColor = void 0;
const hexaColorCodeRegex = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;
exports.HexaColor = {
    is: (strColor) => hexaColorCodeRegex.test(strColor),
};
